(() => {
  const STORAGE_KEY = 'sweetheart-favorites';

  function getFavorites() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(value)) return [];

      return value
        .map((item) => (typeof item === 'string' ? item : item && item.handle))
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function saveFavorites(favorites) {
    const uniqueFavorites = [...new Set(favorites)];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(uniqueFavorites));
    window.dispatchEvent(
      new CustomEvent('favorites:changed', { detail: { favorites: uniqueFavorites } })
    );
  }

  class FavoriteToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.product-card-favorite__button');
      this.handle = this.dataset.productHandle;
      if (!this.button || !this.handle) return;

      this.productTitle = this.button.getAttribute('aria-label')
        .replace(/^Ajouter\s+/, '')
        .replace(/\s+aux favoris$/, '');
      this.onClick = this.toggle.bind(this);
      this.onFavoritesChanged = this.update.bind(this);
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('favorites:changed', this.onFavoritesChanged);
      window.addEventListener('storage', this.onFavoritesChanged);
      this.update();
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('favorites:changed', this.onFavoritesChanged);
      window.removeEventListener('storage', this.onFavoritesChanged);
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();

      const favorites = getFavorites();
      const nextFavorites = favorites.includes(this.handle)
        ? favorites.filter((handle) => handle !== this.handle)
        : [...favorites, this.handle];

      saveFavorites(nextFavorites);
    }

    update() {
      const isFavorite = getFavorites().includes(this.handle);
      this.button.setAttribute('aria-pressed', String(isFavorite));
      this.button.setAttribute(
        'aria-label',
        `${isFavorite ? 'Retirer' : 'Ajouter'} ${this.productTitle} ${
          isFavorite ? 'des' : 'aux'
        } favoris`
      );
      this.button.title = isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris';
    }
  }

  if (!customElements.get('favorite-toggle')) {
    customElements.define('favorite-toggle', FavoriteToggle);
  }
})();
